/**
 * @generated SignedSource<<15f26f106ceb24c4415376c85a5616a7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type CardVersionHistoryFragment$data = {
  readonly analytics: {
    readonly downloadCount: number;
    readonly fileSize: number;
  };
  readonly dataset: {
    readonly id: string;
    readonly owner: {
      readonly username: string;
      readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
    };
    readonly slug: string;
  };
  readonly doi: {
    readonly full: string;
  } | null | undefined;
  readonly id: string;
  readonly publishedAt: DateTime | null | undefined;
  readonly updatedAt: DateTime;
  readonly version: Semver;
  readonly viewerCanDeleteDatasetVersion: boolean;
  readonly viewerCanUpdateDatasetVersion: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionPublishButtonFragment">;
  readonly " $fragmentType": "CardVersionHistoryFragment";
};
export type CardVersionHistoryFragment$key = {
  readonly " $data"?: CardVersionHistoryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CardVersionHistoryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CardVersionHistoryFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dataset",
      "kind": "LinkedField",
      "name": "dataset",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "username",
              "storageKey": null
            },
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "thumbnail",
                  "value": true
                }
              ],
              "kind": "FragmentSpread",
              "name": "EntityProfilePicFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DatasetAnalytics",
      "kind": "LinkedField",
      "name": "analytics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "downloadCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fileSize",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DOI",
      "kind": "LinkedField",
      "name": "doi",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "full",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "viewerCanDeleteDatasetVersion",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "DELETE_DATASET_VERSION"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"DELETE_DATASET_VERSION\")"
    },
    {
      "alias": "viewerCanUpdateDatasetVersion",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "UPDATE_DATASET_VERSION"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"UPDATE_DATASET_VERSION\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DatasetVersionPublishButtonFragment"
    }
  ],
  "type": "DatasetVersion",
  "abstractKey": null
};
})();

(node as any).hash = "7edb54deef2cb74bdce5eaea53707a3c";

export default node;
